<template>
  <div class="container">
    <template v-if="$store.state.ach.achData">
      <overview :achId="achId" />
      <vendor-submitted />
      <verification-call-info />
      <financial-information
        v-if="['AchAdministrator', 'GeneralAccounting'].includes(this.curUserType)"
        :achId="achId"
        @show-bank-info="showBankInfoSuccess"
        @image-viewed="imageViewedSuccess"
      />
      <audit-trail />
    </template>
    <template v-else>
    </template>
  </div>
</template>
<script>
import Overview from '@/pages/ach-request/sections/Overview';
import VendorSubmitted from '@/pages/ach-request/sections/VendorSubmitted';
import FinancialInformation from '@/pages/ach-request/sections/FinancialInformation';
import VerificationCallInfo from '@/pages/ach-request/sections/VerificationCallInfo';
import AuditTrail from '@/pages/ach-request/sections/AuditTrail';

export default {
  name: "AchRequestVerified",
  components: {
    Overview,
    VendorSubmitted,
    FinancialInformation,
    VerificationCallInfo,
    AuditTrail,
  },
  props: {
    achId: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
    curUserType: {
      type: String,
      default: '',
    },
  },
  methods: {
    showBankInfoSuccess() {
      this.$emit('achApiCallSuccess');
    },
    imageViewedSuccess() {
      this.$emit('achApiCallSuccess');
    },
  },
};

</script>
